import { call, put } from 'redux-saga/effects';
import { fetchAsioRolesListForSubscribersSuccess, fetchAsioRolesListForSubscribersFailure } from '../slice';
import { GET, getHeaders } from 'src/services/ApiService';

export function* fetchRolesList() {
    const result = yield call(GET, `/iambff/v1/connected-apps/asio_platform/app-roles`, getHeaders());
    if (result.isSuccess) {
        yield put(
            fetchAsioRolesListForSubscribersSuccess({
                data: result.response,
            })
        );
    } else {
        yield put(fetchAsioRolesListForSubscribersFailure(result));
    }
}
